<template>

    <div class="product-filter">

        <div class="name" @click="active = !active">
            {{ this.name }}
            <span class="expand">
                {{ this.defineSymbol }}
            </span>
        </div>

        <div class="values" :class="{active: this.active}">
            <div v-for="(filter, index) in filters" :key="`filterval-${index}`">
                <nuxt-link :to="{ name: filterPath, query: buildQuery(name, filter.key) }"
                             @click.native="reloadProducts"
                             :class="{'filter-active': checkFilterActive(name, filter)}">
                    {{ filter.value }}
                    <span class="count" v-if="!checkFilterActive(name, filter)">
                        ( {{ filter.doc_count }} )
                    </span>
                </nuxt-link>
            </div>
        </div>

    </div>

</template>

<script>

    export default {
        name: 'product-filter',
        props: {
            filters: {
                type: Array
            },
            name: {
                type: String
            },
            filterPath: {
                type: String,
                default: 'products'
            }
        },
        data: function() {
            return {
                active: false
            }
        },
        computed: {
            defineSymbol() {
                return this.active ? '-' : '+'
            },
            initialActive() {
                this.active = ((this.$route &&
                    this.$route['query'] &&
                    this.$route['query']['search'] &&
                    this.$route['query']['search'][this.name]) ||
                    (this.$route.name == 'categories' && this.name == 'category'))
            }
        },
        methods: {
            reloadProducts() {
                this.$emit('reloadProductsEvent')
            },
            uniq(value, index, self) {
                return self.indexOf(value) === index
            },
            checkFilterActive(name, filter) {
                return ((this.$route['query'] &&
                    this.$route['query']['search'] &&
                    this.$route['query']['search'][name] &&
                    this.$route['query']['search'][name].indexOf(filter.key) >= 0) ||
                    (this.$route.name == 'categories' && this.$route.params['name'] == filter.permalink))
            },
            buildQuery(key, value) {
                let search = (this.$route['query'] && this.$route['query']['search']) ? Object.assign({}, this.$route['query']['search']) : {}
                if (search[key]) {
                    if (search[key].indexOf(value) == -1) {
                        search[key] = search[key].concat([value]) //.filter(this.uniq)
                    } else {
                        search[key] = search[key].concat([value]).filter(el => el != value) //.filter(this.uniq)
                    }
                } else {
                    search[key] = [value]
                }

                return { search }
            }
        },
        mounted() {
            this.initialActive
        }
    }

</script>

<style lang="scss" scoped>
    @import '@/assets/stylesheets/variables.scss';

    .product-filter{
        margin: 6px 0;

        .name{
            padding: 2px;
            font-weight: bold;
            text-transform: capitalize;
            cursor: pointer;

            .expand{
                float: right;
            }
        }

        .values{
            max-height: 150px;
            overflow: auto;
            padding-left: 8px;
            display: none;

            &.active{
                display: block;
            }

            a{
                font-size: 1.4rem;
                line-height: 1.42;
                color: #666666;
                text-decoration: none;

                &:hover, &:visited, &:focus{
                    text-decoration: none;
                    color: #666666;
                }

                &.filter-active{
                    color: $color-dark-gold;
                    font-weight: bold;

                    &::after{
                        color: #666666;
                        content: "\f00d";
                        font-family: "Font Awesome 5 Free";
                        padding: 0 2px;
                        font-size: 1.2rem;
                    }
                }
            }

            .count{
                color: $color-black;
                font-weight: normal;
            }
        }
    }
</style>